import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { AuthService } from './auth.service';

/**
 * Protects the authenticated pages (`/catalog`, `/documentation`). Waits for the
 * initial session check to settle, then redirects unauthenticated visitors to
 * `/login`, preserving the URL they were trying to reach as `returnUrl` so `login()`
 * can send them right back to it after a successful GitHub sign-in.
 */
export const authGuard: CanActivateFn = async (_route, state) => {
  const auth = inject(AuthService);
  const router = inject(Router);

  await auth.ready;

  if (auth.isAuthenticated()) {
    return true;
  }

  return router.createUrlTree(['/login'], { queryParams: { returnUrl: state.url } });
};

/**
 * Protects `/login` from an already-authenticated visitor (e.g. hitting the URL
 * directly, or navigating back after signing in) by bouncing them to `/catalog`.
 */
export const guestGuard: CanActivateFn = async () => {
  const auth = inject(AuthService);
  const router = inject(Router);

  await auth.ready;

  return auth.isAuthenticated() ? router.createUrlTree(['/catalog']) : true;
};
